import apiClient from "@/services/apiClient.js";

export async function SearchByNumber(number) {
  const resp = await apiClient.get(`api/GetNumberData/${number}`);

  return resp.data;
}
export async function SearchByAccountNumber(number) {
  const resp = await apiClient.get(`api/GetAllNumbers/${number}`);

  return resp.data;
}
export async function GetLatestCall(number) {
  const resp = await apiClient.get(`api/GetTwilioData/${number}`);
  return resp.data;
}
